<template>
    <div v-if="$store.getters.logged">
        <div class="position-absolute ms-3 mt-0">
            <a v-if="!showvideo" href="/#/home" class="bi bi-arrow-left-circle-fill fs-2"></a>
            <a v-if="showvideo" @click.prevent="showvideo=false" class="bi bi-arrow-left-circle-fill fs-2"></a>
        </div>

        <div v-if="!showvideo" class="container text-center col-lg-6">
            <div class="row">
                <h1 class="fw-bold">Elenco Materiale E-learning</h1>
            </div>

            <!-- SELEZIONA CORSO -->
            <div class="row mx-2 my-1">
                <select class="form-select rounded-pill" v-model="selectedOptionCorsoId" v-on:change="getMateriale()">
                    <option value="" selected>Seleziona Corso</option>
                    <option v-for="corso in corsi" v-bind:key="corso.Id" :value="corso.Id">{{ corso.Key_Corso__c }} - {{ corso.Name }}</option>
                </select>
            </div>

            <!-- SELEZIONA EDIZIONE CORSO -->
            <div v-if="showElencoEdizioni" class="row mx-2 my-1">
                <select class="form-select rounded-pill" v-model="selectedOptionEdCorsoId">
                    <option value="" selected>Seleziona edizione corso</option>
                    <option v-for="(med, id) in edizioni" :key="id" :value="id">{{ med }}</option>
                </select>
            </div>

            <table class="table table-sm mt-2">
                <thead>
                    <tr>
                        <th class="col-4"><h5 class="fw-bold mb-0 text-start">Materiale</h5></th>
                        <th class="col-3"><h5 class="fw-bold mb-0 text-start">Formato</h5></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="m in elencoMateriale" v-bind:key="m.Id" @click="selectMateriale(m)">
                        <th class="text-start align-middle ps-2">
                            <a href="#" >{{ m.Name }}</a>
                        </th>
                        <th class="text-start align-middle ps-2">{{ m.Tipo_Risorsa__c }}</th>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="showvideo" class="container text-center col-lg-6">
            <div class="row">
                <div class="row">
                    <h1 class="fw-bold">Elenco Materiale E-learning</h1>
                </div>

                <div class="col mx-auto">
                    <h2 class="centratox ">{{ materialeSelected.Name }}</h2>
                    <p class="centratox">È consigliabile utilizzare il dispositivo in orizzontale.
                        <img src="img/landscape.png" style="width: 32px">
                    </p>
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe  v-bind:src="materialeSelected.Link_Risorsa__c" width="640" height="360" style="border:none" class="embed-responsive-item" 
                                allow="autoplay; fullscreen" allowfullscreen="yes" scrolling="no" marginheight="0" marginwidth="0">
                        </iframe>
                    </div>
                    <div style="padding-top:20px;">
                        <button class="btn-sm" v-on:click="showvideo=false">Indietro</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Elearning',
    components:{},
    data() {
        return {
            corsi: [],
            showvideo: false,
            materiale: [],
            selectedOptionCorsoId: '',
            materialeSelected: {},
            edizioni: {},
            materialeEdiz: {},
            selectedOptionEdCorsoId: '',
            showElencoEdizioni: false
        }
    },
    computed: {
        elencoMateriale() {
            if(this.selectedOptionEdCorsoId) return this.materialeEdiz[this.selectedOptionEdCorsoId]
            return this.materiale
        }
    },
    created(){
        this.getCorsi();
    },
    methods:{
        getCorsi:function(){
            var self=this;
            console.log('getCorsi elearning');
            this.$store.dispatch('getCorsiConElearning')
            .then(resp => {
                console.log('corsi: ',resp);
                self.corsi = Object.values(resp)
                self.corsi = this.sortObjectsList(self.corsi, 'Name')
            })
        },
        getMateriale() {
            console.log('idCorso: ',this.selectedOptionCorsoId)
            this.selectedOptionEdCorsoId = ''
            this.materialeEdiz = {}
            this.edizioni = {}
            this.showElencoEdizioni = false
            var self=this;
            this.$store.dispatch('getMaterialeElearning', { corso: this.selectedOptionCorsoId })
            .then(resp => {
                console.log('materiale: ',resp);
                self.materiale = resp
                for(var m of resp) {
                    if(m.Edizione_Corso__c) {
                        if(!this.edizioni[m.Edizione_Corso__c]) this.edizioni[m.Edizione_Corso__c] = m.Edizione_Corso__r.Name

                        if(!this.materialeEdiz[m.Edizione_Corso__c]) this.materialeEdiz[m.Edizione_Corso__c] = [m]
                        else this.materialeEdiz[m.Edizione_Corso__c].push(m)
                    }
                }
                if(Object.keys(this.edizioni).length > 0) this.showElencoEdizioni = true
            })
        },
        selectMateriale(m) {
            this.showvideo = true
            this.materialeSelected = m
        },
        sortObjectsList(items, field) {
            return items.sort((a, b) => {
                const fieldA = a[field].toUpperCase();
                const fieldB = b[field].toUpperCase();
                if (fieldA < fieldB) return -1;
                if (fieldA > fieldB) return 1;
                return 0;
            });
        }
    }
  }
</script>
